import React from 'react'
import { Navigate, Outlet } from 'react-router'

import { ROUTES } from '../../constants/routes'
import { SEARCH_PARAMS } from '../../constants/searchParams'
import { useCurrentUser } from '../../hooks/useCurrentUser'
import { useIsRoute } from '../../hooks/useIsRoute'
import { currentPath } from '../../lib/helpers/domHelpers'
import AppHeader from '../AppHeader'
import Footer from '../Footer'
import BannerNotification from '../misc/BannerNotification/BannerNotification'
import { MainContent } from '../misc/MainContent'
import { SentryErrorBoundary } from '../misc/SentryErrorBoundary'
import Hidden from '../utils/Hidden'

export default function AppLayout() {
  const currentUser = useCurrentUser()
  const isRoute = useIsRoute()

  if (!currentUser) {
    return (
      <Navigate
        to={`${ROUTES.login()}?${SEARCH_PARAMS.shared.returnUrl}=${currentPath()}`}
      />
    )
  }

  const shouldRedirectToEmailVerificationRequiredPage =
    currentUser &&
    !currentUser.emailVerifiedAt &&
    !isRoute([ROUTES._emailVerificationRequired, ROUTES._verifyEmail])

  if (shouldRedirectToEmailVerificationRequiredPage) {
    return <Navigate to={ROUTES.emailVerificationRequired()} />
  }

  return (
    <>
      <AppHeader />

      <Hidden>
        <BannerNotification />
      </Hidden>

      <MainContent>
        <SentryErrorBoundary>
          <Outlet />
        </SentryErrorBoundary>
      </MainContent>
      <Footer />
    </>
  )
}
